import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class goodwillMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Event Info
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Goodwill Message
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    {/* <section class="Associates_Partners_section">
    <div class="container">
  <div class="row" data-aos="fade-up" data-aos-delay="300">
     <div class="col-md-12 text-center" >
          <div class="selector">
              <h2 class="ah-headline letters rotate-3">
                <span class="position_relative yellow_color">Goodwill Messages</span>
              </h2>
          </div>
     </div>
  </div>

  <div class="row mt_40">
      <div class="col-md-12">
          <div class="GoodwillMessages_grid_View">
              <div class="main_div">
                  <img src="assets/img/GoodwillMessage_1.jpg" />
                  <div class="content_div">
                      <h3>Shri. Piyush Goyal</h3>
                      <p>Minister of Textiles, <br/>Government of India</p>
                      <a href="#" class="read_more_btn">View</a>
                  </div>
              </div>
              <div class="main_div">
                  <img src="assets/img/GoodwillMessage_2.jpg" />
                  <div class="content_div">
                      <h3>Shri. U. P. Singh</h3>
                      <p>IAS, Secretary, <br/>Ministry of Textiles, Government of India</p>
                      <a href="#" class="read_more_btn">View</a>
                  </div>
              </div>
              <div class="main_div">
                  <img src="assets/img/GoodwillMessage_3.jpg" />
                  <div class="content_div">
                      <h3>Shri. Subhash Desai</h3>
                      <p>Minister, Industries and Mining, <br/>Government of Maharashtra</p>
                      <a href="#" class="read_more_btn">View</a>
                  </div>
              </div>
          </div>
      </div>
    </div>

    </div>
</section> */}
                    <section className="Visitior_guide_section" style={{ height: "100vh" }}>
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Directory</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">
                                                Goodwill Messages
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(goodwillMessage));